import Loadable from "react-loadable";

import MainLoadingComponent from "../../components/mainLoading";

export const AsyncCommunitySettings: any = Loadable({
    loader: () => import("containers/CommunitySettings"),
    loading: MainLoadingComponent
});

export const AsyncGroupRequests: any = Loadable({
    loader: () => import("containers/groupRequests"),
    loading: MainLoadingComponent
});

export const AsyncChannels: any = Loadable({
    loader: () => import("containers/channels"),
    loading: MainLoadingComponent
});

export const AsyncChannelMembers: any = Loadable({
    loader: () => import("containers/channels/channelMembers"),
    loading: MainLoadingComponent
});

export const AsyncChannelDetails: any = Loadable({
    loader: () => import("containers/channels/channelDetails"),
    loading: MainLoadingComponent
});

export const AsyncCollections: any = Loadable({
    loader: () => import("containers/channels/collections"),
    loading: MainLoadingComponent
});

export const AsyncCustomDomain: any = Loadable({
    loader: () => import("containers/customDomain"),
    loading: MainLoadingComponent
});

export const AsyncGroupConfirmation: any = Loadable({
    loader: () => import("containers/groupConfirmation"),
    loading: MainLoadingComponent
});

export const AsyncGroupBilling2: any = Loadable({
    loader: () => import("containers/groupBilling/GroupBilling2"),
    loading: MainLoadingComponent
});

export const AsyncGroupPricing: any = Loadable({
    loader: () => import("containers/groupAppPricing"),
    loading: MainLoadingComponent
});

export const AsyncAppSumoPricing: any = Loadable({
    loader: () => import("containers/appSumoPricing"),
    loading: MainLoadingComponent
});

export const AsyncGroupUpgrade: any = Loadable({
    loader: () => import("containers/groupUpgrade"),
    loading: MainLoadingComponent
});

export const AsyncInviteUsers: any = Loadable({
    loader: () => import("containers/InviteUsers"),
    loading: MainLoadingComponent
});

export const AsyncIndividualInvite: any = Loadable({
    loader: () => import("containers/IndividualInvites"),
    loading: MainLoadingComponent
});

export const AsyncAnalytics: any = Loadable({
    loader: () => import("containers/AnalyticsContainer"),
    loading: MainLoadingComponent
});

export const AsyncMembershipSubscription: any = Loadable({
    loader: () => import("containers/MembershipSubscription"),
    loading: MainLoadingComponent
});


export const AsyncCourseEdit: any = Loadable({
    loader: () => import("containers/Library/Admin/Courses/CourseEditContainer"),
    loading: MainLoadingComponent
});

export const AsyncLibraryContentIntro: any = Loadable({
    loader: () => import("containers/Library/Admin/LibraryContentIntro"),
    loading: MainLoadingComponent
})

export const AsyncAddAuthorizedUsersComponent: any = Loadable({
    loader: () => import("containers/Library/Admin/Courses/AddAuthorizedUsers/AddAuthorizedUsersComponent"),
    loading: MainLoadingComponent,
});

export const AsyncLibraryAdminContainer: any = Loadable({
    loader: () => import("containers/Library/Admin"),
    loading: MainLoadingComponent
});

export const AsyncEventsContainer: any = Loadable({
    loader: () => import("containers/events/EventsAdminContainer"),
    loading: MainLoadingComponent
});

export const AsyncTeams: any = Loadable({
    loader: () => import("containers/teamsContainer"),
    loading: MainLoadingComponent
});

export const AsyncModeration: any = Loadable({
    loader: () => import("containers/moderationContainer"),
    loading: MainLoadingComponent
});

export const AsyncIntegrations: any = Loadable({
    loader: () => import("containers/IntegrationsContainer"),
    loading: MainLoadingComponent
});

export const AsyncOnboarding: any = Loadable({
    loader: () => import("containers/Onboarding"),
    loading: MainLoadingComponent
});

export const AsyncAdminMessaging: any = Loadable({
    loader: () => import("containers/AdminMessaging"),
    loading: MainLoadingComponent
});

export const AsyncAdminMessagingWizard: any = Loadable({
    loader: () => import("containers/AdminMessaging/AdminMessagingWizard"),
    loading: MainLoadingComponent
});

export const AsyncWorkflowCreation2: any = Loadable({
    loader: () => import("containers/Workflows/WorkflowCreation2/WorkflowCreation2"),
    loading: MainLoadingComponent
});

export const AsyncActiveUsersInWorkflow: any = Loadable({
    loader: () => import("containers/Workflows/ActiveUsersInWorkflow/ActiveUsersInWorkflow"),
    loading: MainLoadingComponent
});

export const AsyncWorflows: any = Loadable({
    loader: () => import("containers/Workflows"),
    loading: MainLoadingComponent
});

export const AsyncCommunityHomePage: any = Loadable({
    loader: () => import("containers/CommunityHomePage/Admin"),
    loading: MainLoadingComponent
});

export const AsyncCommunitySegments: any = Loadable({
    loader: () => import("containers/CommunitySegments"),
    loading: MainLoadingComponent
});

export const AsyncSegmentMembers: any = Loadable({
    loader: () => import("containers/CommunitySegments/SegmentMembers"),
    loading: MainLoadingComponent
});

export const AsyncCreateCommunityResource: any = Loadable({
    loader: () => import("containers/communityResource/resourceCreation"),
    loading: MainLoadingComponent
});

export const AsyncPageBuilder: any = Loadable({
    loader: () => import("containers/PageBuilder"),
    loading: MainLoadingComponent
});

export const AsyncSinglePageContainer: any = Loadable({
    loader: () => import("containers/PageBuilder/SinglePageContainer"),
    loading: MainLoadingComponent
});

export const AsyncCertificatesContainer: any = Loadable({
    loader: () => import("containers/CoursesContainer/CertificatesContainer"),
    loading: MainLoadingComponent
});

export const AsyncCertificateBuilder: any = Loadable({
    loader: () => import("containers/CoursesContainer/CertificateBuilder"),
    loading: MainLoadingComponent
});

export const AsyncCertificateIssuedContainer: any = Loadable({
    loader: () => import("containers/CoursesContainer/CertificatesContainer/CertificateIssuedContainer"),
    loading: MainLoadingComponent
});


export const AsyncCommunityBranding: any = Loadable({
    loader: () => import("containers/CommunityBranding/CommunityBranding"),
    loading: MainLoadingComponent
});

export const AsyncAdminDashboard: any = Loadable({
    loader: () => import("containers/AdminDashboard"),
    loading: MainLoadingComponent
});

export const AsyncMembershipSubscriptionDetails: any = Loadable({
    loader: () => import("containers/MembershipSubscription/MembershipSubscriptionDetails"),
    loading: MainLoadingComponent
});